import {TEMP_PATH_PART, type TempExpressionPath} from '../shared';

export const TEMP_NAVBAR_MENU_PATH: TempExpressionPath = [
  TEMP_PATH_PART,
  {in: 'Record', at: 'navbar'},
  {in: 'Record', at: 'menu'},
];
